import Vue from 'vue';
import Router from 'vue-router';
import { setOrigin } from 'ym-reporter-vue';
import store from '@/store';
import {
  getAuth,
  setAuth,
  isAppWebView,
  locationHref,
  setYmDevice,
  isMiniWebView,
} from '@/utils';
import { setWechatConfig, updateWechatShareInfo } from '@/utils/share';
import { getUserLoginWithToken } from '@/services/user';
import {
  MINI_PROGRAM_TOKEN_NAME,
  APP_TOKEN_NAME,
} from '@/utils/constant';
import reloadPage from '@/utils/reload';
import { locationToAppWithRoute } from '@/utils/app-route';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    // 公司品牌介绍页
    {
      path: '/',
      name: 'CompanyBrand',
      component: () => import('@/pages/CompanyBrand').catch(reloadPage),
    },
    {
      // 首页
      path: '/index',
      name: 'Home',
      component: () => import('@/pages/Home').catch(reloadPage),
      meta: { tab: true },
    },
    {
      // 搜索
      path: '/search',
      name: 'Search',
      component: () => import('@/pages/Search').catch(reloadPage),
    },
    {
      // 专题详情
      path: '/topic/:id(\\d+)',
      name: 'TopicDetail',
      component: () => import('@/pages/Topic/Detail').catch(reloadPage),
    },
    {
      // 学院详情
      path: '/college/:id(\\d+)',
      name: 'CollegeDetail',
      component: () => import('@/pages/College/Detail').catch(reloadPage),
    },
    {
      // 产品分类
      path: '/:type(\\w+)/category',
      name: 'Category',
      component: () => import('@/pages/Category').catch(reloadPage),
    },
    {
      // 音频首页
      path: '/audio',
      name: 'Audio',
      component: () => import('@/pages/Audio').catch(reloadPage),
      meta: { tab: true },
    },
    {
      // 音频列表
      path: '/audio/explore',
      name: 'AudioList',
      component: () => import('@/pages/Audio/List').catch(reloadPage),
    },
    {
      // 排行榜
      path: '/ranking/list',
      name: 'RankingList',
      component: () => import('@/pages/Ranking/List').catch(reloadPage),
    },
    {
      // 音频免费专区
      path: '/audio/free',
      name: 'AudioFree',
      component: () => import('@/pages/Audio/Free').catch(reloadPage),
    },
    {
      // 音频详情
      path: '/audio/:id(\\d+)',
      name: 'AudioDetail',
      component: () => import('@/pages/Audio/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 音频介绍详情页
      path: '/:type(\\w+)/:id(\\d+)/introduction',
      name: 'ProductIntroductionDetail',
      component: () => import('@/pages/ProductIntroduction').catch(reloadPage),
    },
    {
      // 音频节目详情
      path: '/audio/program/:id(\\d+)',
      name: 'AudioProgramDetail',
      component: () => import('@/pages/AudioProgram/Detail').catch(reloadPage),
    },
    {
      // 视频节目详情
      path: '/video/program/:id(\\d+)',
      name: 'VideoProgramDetail',
      component: () => import('@/pages/VideoProgram/Detail').catch(reloadPage),
    },
    {
      // 音频节目评价
      path: '/program/:id(\\d+)/review',
      name: 'ProgramReviewList',
      component: () => import('@/pages/AudioProgram/ReviewList').catch(reloadPage),
      meta: { internalJumpWebview: true },
    },
    {
      // 直播课首页
      path: '/course',
      name: 'Course',
      component: () => import('@/pages/Course').catch(reloadPage),
      meta: { tab: true },
    },
    {
      // 直播课列表
      path: '/course/explore',
      name: 'CourseList',
      component: () => import('@/pages/Course/List').catch(reloadPage),
    },
    {
      // 直播课详情
      path: '/course/:id(\\d+)',
      name: 'CourseDetail',
      component: () => import('@/pages/Course/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 直播课详情课前须知
      path: '/course/class/notice/:id(\\d+)',
      name: 'CourseClassNotice',
      component: () => import('@/pages/Course/Notice').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 直播课详情试听详情
      path: '/course/try/detail/:id(\\d+)',
      name: 'CourseTryDetail',
      component: () => import('@/pages/Course/Try').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 线下项目首页
      path: '/project',
      name: 'Project',
      component: () => import('@/pages/Project').catch(reloadPage),
    },
    {
      // 线下项目列表
      path: '/project/explore',
      name: 'ProjectList',
      component: () => import('@/pages/Project/List').catch(reloadPage),
    },
    {
      // 线下项目详情
      path: '/project/:id(\\d+)',
      name: 'ProjectDetail',
      component: () => import('@/pages/Project/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 家长课堂首页
      path: '/parents',
      name: 'Parents',
      component: () => import('@/pages/Parents').catch(reloadPage),
    },
    {
      // 学习计划调查
      path: '/learning/survey',
      name: 'LearningSurvey',
      component: () => import('@/pages/LearningSurvey').catch(reloadPage),
    },
    {
      // 学习计划调查结果页
      path: '/learning/survey/result',
      name: 'LearningSurveyResult',
      component: () => import('@/pages/LearningSurvey/Result').catch(reloadPage),
    },
    {
      // 学习计划购买页
      path: '/plan/:id(\\d+)',
      name: 'PlanDetail',
      component: () => import('@/pages/Plan/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 系列列表
      path: '/combo/explore',
      name: 'ComboList',
      component: () => import('@/pages/Combo/List').catch(reloadPage),
    },
    {
      // 音频系列详情
      path: '/combo/audio/:id(\\d+)',
      name: 'AudioComboDetail',
      component: () => import('@/pages/Combo/AudioComboDetail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 课程系列详情
      path: '/combo/course/:id(\\d+)',
      name: 'CourseComboDetail',
      component: () => import('@/pages/Combo/CourseComboDetail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 复合系列详情
      path: '/combo/multi/:id(\\d+)',
      name: 'MultiComboDetail',
      component: () => import('@/pages/Combo/MultiComboDetail').catch(reloadPage),
    },
    {
      // 通用系列详情
      path: '/combo/:id(\\d+)',
      name: 'ComboDetail',
      component: () => import('@/pages/Combo/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 训练营主页
      path: '/training',
      name: 'Training',
      component: () => import('@/pages/Training').catch(reloadPage),
    },
    {
      // 训练营列表页
      path: '/training/list',
      name: 'TrainingList',
      component: () => import('@/pages/Training/List').catch(reloadPage),
    },
    {
      // 训练营详情
      path: '/training/:id(\\d+)',
      name: 'TrainingDetail',
      component: () => import('@/pages/Training/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 训练营证书
      path: '/training/:id(\\d+)/certificate',
      name: 'TrainingCertificate',
      component: () => import('@/pages/Training/Certificate').catch(reloadPage),
    },
    {
      // 训练营关卡详情
      path: '/training/level/:id(\\d+)',
      name: 'TrainingLevelDetail',
      component: () => import('@/pages/TrainingLevel/Detail').catch(reloadPage),
    },
    {
      // 训练营任务详情
      path: '/training/task/:id(\\d+)',
      name: 'TrainingTaskDetail',
      component: () => import('@/pages/TrainingTask/Detail').catch(reloadPage),
    },
    {
      // 训练营完成作品通知
      path: '/training/work/:id(\\d+)/notify',
      name: 'TrainingWorkNotify',
      component: () => import('@/pages/TrainingWork/Notify').catch(reloadPage),
    },
    {
      // 训练营作品详情
      path: '/training/work/:id(\\d+)',
      name: 'TrainingWorkDetail',
      component: () => import('@/pages/TrainingWork/Detail').catch(reloadPage),
    },
    {
      // 训练营作品分享详情
      path: '/training/work/:id(\\d+)/share',
      name: 'TrainingWorkDetailShare',
      component: () => import('@/pages/TrainingWork/Share').catch(reloadPage),
    },
    {
      // 开团页
      path: '/group/buy/:id(\\d+)/create',
      name: 'GroupBuyCreate',
      component: () => import('@/pages/GroupBuy/Create').catch(reloadPage),
    },
    {
      // 拼团队伍详情
      path: '/group/buy/team/:id(\\d+)',
      name: 'GroupBuyTeamDetail',
      component: () => import('@/pages/GroupBuy/TeamDetail').catch(reloadPage),
    },
    {
      // 领取优惠券
      path: '/coupon/collect',
      name: 'ReceiveCoupon',
      component: () => import('@/pages/Receive').catch(reloadPage),
    },
    {
      // 作品首页
      path: '/work',
      name: 'WorkIndex',
      component: () => import('@/pages/Work').catch(reloadPage),
    },
    {
      // 作品列表
      path: '/work/explore',
      name: 'WorkList',
      component: () => import('@/pages/Work/List').catch(reloadPage),
    },
    {
      // 作品详情
      path: '/work/:id(\\d+)',
      name: 'WorkDetail',
      component: () => import('@/pages/Work/Detail').catch(reloadPage),
    },
    // 学员心声首页
    {
      path: '/student/gains',
      name: 'StudentGains',
      component: () => import('@/pages/StudentGains/index').catch(reloadPage),
    },
    // 学员心声详情
    {
      path: '/student/gains/:id(\\d+)',
      name: 'StudentGainsDetail',
      component: () => import('@/pages/StudentGains/Detail').catch(reloadPage),
    },
    {
      // 会员详情
      path: '/vip/:id(\\d+)',
      name: 'VipDetail',
      component: () => import('@/pages/Vip/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 实物详情
      path: '/entity/:id(\\d+)',
      name: 'EntityDetail',
      component: () => import('@/pages/Entity/Detail').catch(reloadPage),
      meta: { backRefresh: true },
    },
    {
      // 领取体验会员
      path: '/receive/experience/vip/:id(\\d+)',
      name: 'ReceiveExperienceVip',
      component: () => import('@/pages/Vip/ReceiveExperience').catch(reloadPage),
    },
    {
      // 收银台
      path: '/pay/center',
      name: 'PayCenter',
      component: () => import('@/pages/Pay/Center').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 调起支付中间页
      path: '/pay/index',
      name: 'Pay',
      component: () => import('@/pages/Pay').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 支付成功通知
      path: '/pay/notify/:sn(\\w+)',
      name: 'PayNotify',
      component: () => import('@/pages/Pay/Notify').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 支付等待
      path: '/pay/waiting',
      name: 'PayWaiting',
      component: () => import('@/pages/Pay/Waiting').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 提示信息页
      path: '/prompt/message',
      name: 'PromptMessage',
      component: () => import('@/pages/Common/PromptMessage').catch(reloadPage),
    },
    {
      // 客服咨询
      path: '/:type(\\w+)/:id(\\d+)/customer/service',
      name: 'CustomerService',
      component: () => import('@/pages/CustomerService').catch(reloadPage),
      meta: { selfJumpWebview: true },
    },
    {
      // 登录
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/Login').catch(reloadPage),
      meta: { selfJumpWebview: true },
    },
    {
      // 绑定手机号
      path: '/bind/mobile',
      name: 'BindMobile',
      component: () => import('@/pages/Login/BindMobile').catch(reloadPage),
    },
    {
      // 注册
      path: '/register',
      name: 'Register',
      component: () => import('@/pages/Register').catch(reloadPage),
    },
    {
      // 微信登陆
      path: '/register/wechat',
      name: 'RegisterWechat',
      component: () => import('@/pages/Register/Wechat').catch(reloadPage),
    },
    {
      // 微信登陆结果页
      path: '/register/wechat/result',
      name: 'RegisterWechatResult',
      component: () => import('@/pages/Register/WechatResult').catch(reloadPage),
    },
    {
      // 忘记密码
      path: '/password/reset',
      name: 'PasswordReset',
      component: () => import('@/pages/PasswordReset').catch(reloadPage),
    },
    {
      // 修改密码
      path: '/password/modify',
      name: 'PasswordModify',
      component: () => import('@/pages/PasswordModify').catch(reloadPage),
    },
    {
      // 学习模块首页
      path: '/learning',
      name: 'Learning',
      component: () => import('@/pages/Learning').catch(reloadPage),
      meta: { tab: true, internalJumpWebview: true },
    },
    {
      // 个人中心
      path: '/my',
      name: 'Mine',
      component: () => import('@/pages/My').catch(reloadPage),
      meta: { tab: true, internalJumpWebview: true },
    },
    {
      // 小程序webview审核版 个人中心
      path: '/my/mini',
      name: 'MineMiniIndex',
      component: () => import('@/pages/My/MiniIndex').catch(reloadPage),
      meta: { tab: true, internalJumpWebview: true },
    },
    {
      // 账户信息
      path: '/my/setting',
      name: 'MySetting',
      component: () => import('@/pages/MySetting').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 设置学校
      path: '/settings/school',
      name: 'MySchoolSetting',
      component: () => import('@/pages/MySetting/SchoolSetting').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 设置阅读兴趣
      path: '/settings/reading/interest',
      name: 'MyReadingInterest',
      component: () => import('@/pages/MySetting/ReadingInterest').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 设置收件地址
      path: '/address/setting',
      name: 'AddressSetting',
      component: () => import('@/pages/AddressSetting/List').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 收件地址详情页（新增或编辑）
      path: '/address/detail',
      name: 'AddressDetailSetting',
      component: () => import('@/pages/AddressSetting/Detail').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 我的音频
      path: '/my/audio',
      name: 'MyAudio',
      component: () => import('@/pages/My/Audio').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    // 我的学习计划列表
    {
      path: '/my/plan/list',
      name: 'MyPlanList',
      component: () => import('@/pages/MyPlan/List').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    // 我的学习计划详情
    {
      path: '/my/plan/:id(\\d+)',
      name: 'MyPlanDetail',
      component: () => import('@/pages/MyPlan/Detail').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    // 我的学习计划每日分享
    {
      path: '/my/plan/:id(\\d+)/share',
      name: 'MyPlanShareDate',
      component: () => import('@/pages/MyPlan/ShareDate').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的课程
      path: '/my/course',
      name: 'MyCourse',
      component: () => import('@/pages/My/Schedule').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 评价产品
      path: '/review/:type(\\w+)/:id(\\d+)/create',
      name: 'CreateReview',
      component: () => import('@/pages/Review/Create').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的项目
      path: '/my/project',
      name: 'MyProject',
      component: () => import('@/pages/My/Project').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的作品
      path: '/my/work',
      name: 'MyWork',
      component: () => import('@/pages/My/Work').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的勋章
      path: '/my/medal',
      name: 'MyMedal',
      component: () => import('@/pages/My/Medal').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的优惠券
      path: '/my/coupon',
      name: 'MyCoupon',
      component: () => import('@/pages/My/Coupon').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 我的订单
      path: '/my/order',
      name: 'MyOrder',
      component: () => import('@/pages/My/Order').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 订单详情
      path: '/order/detail/:sn(\\w+)',
      name: 'OrderDetail',
      component: () => import('@/pages/Order/Detail').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 物流详情
      path: '/express/detail/:sn(\\w+)',
      name: 'ExpressDetail',
      component: () => import('@/pages/Express/Detail').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的拼团
      path: '/my/group/purchase',
      name: 'MyGroupBuy',
      component: () => import('@/pages/My/GroupBuy').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 待完成挑战列表
      path: '/my/challenge',
      name: 'MyChallenge',
      component: () => import('@/pages/My/Challenge').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 待完成挑战详情
      path: '/my/challenge/:id(\\d+)',
      name: 'ChallengeList',
      component: () => import('@/pages/Challenge').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 挑战详情
      path: '/challenge/:id(\\d+)',
      name: 'ChallengeDetail',
      component: () => import('@/pages/Challenge/Detail').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的课表
      path: '/my/schedule',
      name: 'MySchedule',
      component: () => import('@/pages/My/Schedule').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 往期回放详情
      path: '/my/schedule/:id(\\d+)',
      name: 'MyScheduleDetail',
      component: () => import('@/pages/My/ScheduleDetail').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 赠送记录
      path: '/my/give/record',
      name: 'MyGiveRecord',
      component: () => import('@/pages/My/GiveRecord').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 赠送页面
      path: '/my/gift/:code(\\w+)',
      name: 'GiftDetail',
      component: () => import('@/pages/Gift/Detail').catch(reloadPage),
      meta: { auth: true },
    },
    // 我的训练营列表
    {
      path: '/my/training/list',
      name: 'MyTrainingList',
      component: () => import('@/pages/My/Training').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 订阅开课提醒
      path: '/my/remind',
      name: 'MyRemind',
      component: () => import('@/pages/My/Remind').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 我的证书
      path: '/my/certificate',
      name: 'CertificateList',
      component: () => import('@/pages/Certificate/List').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 证书详情
      path: '/certificate/:id(\\d+)',
      name: 'CertificateDetail',
      component: () => import('@/pages/Certificate/Detail').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 学习报告
      path: '/my/report',
      name: 'MyReportList',
      component: () => import('@/pages/MyReport/List').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 学习报告详情
      path: '/report/:id(\\d+)',
      name: 'MyReportDetail',
      component: () => import('@/pages/MyReport/Detail').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的消息
      path: '/my/information',
      name: 'MyInformation',
      component: () => import('@/pages/My/MyInformation').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的收藏
      path: '/my/collect',
      name: 'MyCollect',
      component: () => import('@/pages/My/Collect').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 我的私信
      path: '/message',
      name: 'Message',
      component: () => import('@/pages/Message/List').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 私信详情
      path: '/message/:id(\\d+)',
      name: 'MessageDetail',
      component: () => import('@/pages/Message/Detail').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 系统通知
      path: '/notification',
      name: 'Notification',
      component: () => import('@/pages/Notification').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 邀请好友
      path: '/my/invitation',
      name: 'MyInvite',
      component: () => import('@/pages/My/Invitaion').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 会员中心
      path: '/my/vip',
      name: 'MyVipCenter',
      component: () => import('@/pages/MyVip').catch(reloadPage),
      meta: { auth: true, internalJumpWebview: true },
    },
    {
      // 邀请体验会员
      path: '/my/vip/:id(\\d+)/invite/experience',
      name: 'MyVipInviteExperience',
      component: () => import('@/pages/MyVip/InviteExperience').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 系统设置
      path: '/system/settings',
      name: 'SystemSetting',
      component: () => import('@/pages/SystemSetting').catch(reloadPage),
    },
    {
      // 账户安全
      path: '/account/security',
      name: 'AccountSecurity',
      component: () => import('@/pages/SystemSetting/AccountSecurity').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 提醒设置
      path: '/settings/unsubscribe',
      name: 'SubscribeSetting',
      component: () => import('@/pages/SystemSetting/SubscribeSetting').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 自动连续播放设置
      path: '/settings/auto/play/next',
      name: 'AutoContinuousPlay',
      component: () => import('@/pages/SystemSetting/AutoContinuousPlay').catch(reloadPage),
    },
    {
      // 定时关闭设置
      path: '/settings/timed/off',
      name: 'TimedOff',
      component: () => import('@/pages/SystemSetting/TimedOff').catch(reloadPage),
    },
    {
      // 更改手机号
      path: '/modify/mobile',
      name: 'ModifyMobile',
      component: () => import('@/pages/ModifyMobile/index').catch(reloadPage),
    },
    {
      // 通过密码更改手机号
      path: '/modify/mobile/by/password',
      name: 'ModifyMobileByPassword',
      component: () => import('@/pages/ModifyMobile/PassWord').catch(reloadPage),
    },
    {
      // 通过手机验证码更改手机号
      path: '/modify/mobile/by/sms',
      name: 'ModifyMobileBySMS',
      component: () => import('@/pages/ModifyMobile/SMS').catch(reloadPage),
    },
    {
      // 帮助中心
      path: '/faq',
      name: 'HelpCenter',
      component: () => import('@/pages/HelpCenter').catch(reloadPage),
    },
    {
      // 帮助中心分类列表
      path: '/faq/list/:id(\\d+)',
      name: 'HelpCenterCategory',
      component: () => import('@/pages/HelpCenter/Category').catch(reloadPage),
    },
    {
      // 意见反馈
      path: '/feedback',
      name: 'Feedback',
      component: () => import('@/pages/Feedback').catch(reloadPage),
    },
    {
      // 服务协议
      path: '/user/term',
      name: 'UserTerm',
      component: () => import('@/pages/About/UserTerm').catch(reloadPage),
    },
    {
      // 支付协议
      path: '/payment/agreement',
      name: 'PaymentAgreement',
      component: () => import('@/pages/About/PaymentAgreement').catch(reloadPage),
    },
    {
      // 服务协议
      path: '/service/agreement',
      name: 'ServiceAgreement',
      component: () => import('@/pages/About/ServiceAgreement').catch(reloadPage),
    },
    {
      // 隐私政策
      path: '/privacy/policy',
      name: 'PrivacyPolicy',
      component: () => import('@/pages/About/PrivacyPolicy').catch(reloadPage),
    },
    {
      // 直播课时
      path: '/classroom',
      name: 'ClassRoomDetail',
      component: () => import('@/pages/ClassRoom').catch(reloadPage),
      meta: { auth: true },
    },
    {
      // 联系我们
      path: '/contactus',
      name: 'ContactUs',
      component: () => import('@/pages/ContactUs').catch(reloadPage),
    },
    {
      // 关于我们
      path: '/aboutus',
      name: 'AboutUs',
      component: () => import('@/pages/AboutUs').catch(reloadPage),
    },
    {
      // 加入我们
      path: '/joinus',
      name: 'JoinUs',
      component: () => import('@/pages/JoinUs').catch(reloadPage),
    },
    {
      // 动态列表
      path: '/article/list',
      name: 'ArticleList',
      component: () => import('@/pages/Article/List').catch(reloadPage),
    },
    {
      // 动态详情
      path: '/article/:id(\\d+)',
      name: 'ArticleDetail',
      component: () => import('@/pages/Article/Detail').catch(reloadPage),
    },
    {
      // 学校合作
      path: '/partner',
      name: 'CompanyPartner',
      component: () => import('@/pages/CompanyPartner').catch(reloadPage),
    },
    {
      // 课程体系
      path: '/oursystem',
      name: 'OurSystem',
      component: () => import('@/pages/OurSystem').catch(reloadPage),
    },
    {
      // 家长口碑
      path: '/honour',
      name: 'Honour',
      component: () => import('@/pages/Honour').catch(reloadPage),
    },
    {
      // 课程指引
      path: '/course/guide',
      name: 'CourseGuide',
      component: () => import('@/pages/CourseGuide').catch(reloadPage),
    },
    {
      // 研学收获
      path: '/project/work/:projectId(\\d+)/:userId(\\d+)',
      name: 'ProjectWork',
      component: () => import('@/pages/ProjectWork/Work').catch(reloadPage),
    },
    {
      // 研学日记
      path: '/project/diary/:projectId(\\d+)/:userId(\\d+)',
      name: 'ProjectDiary',
      component: () => import('@/pages/ProjectWork/Diary').catch(reloadPage),
    },
    {
      // 照片展示
      path: '/project/image',
      name: 'ProjectImage',
      component: () => import('@/pages/ProjectWork/ImageBlock').catch(reloadPage),
    },
    {
      // 秒杀首页
      path: '/seckill',
      name: 'Seckill',
      component: () => import('@/pages/Seckill/index').catch(reloadPage),
    },
    {
      path: '/test/app/route',
      name: 'Test',
      component: () => import('@/pages/Test').catch(reloadPage),
    },
    // 教育专栏
    {
      path: '/education/column',
      name: 'EducationColumn',
      component: () => import('@/pages/EducationColumn').catch(reloadPage),
    },
    {
      path: '/education/column/:type(\\w+)/activity/list',
      name: 'EducationColumnActivityList',
      component: () => import('@/pages/EducationColumn/ActivityList').catch(reloadPage),
    },
    {
      path: '/education/column/selected/article/list',
      name: 'EducationColumnSelectedArticleList',
      component: () => import('@/pages/EducationColumn/SelectedArticleList').catch(reloadPage),
    },
    {
      path: '/education/column/columnist/list',
      name: 'EducationColumnColumnistList',
      component: () => import('@/pages/EducationColumn/ColumnistList').catch(reloadPage),
    },
    {
      path: '/education/column/columnist/:id(\\d+)',
      name: 'EducationColumnColumnistDetail',
      component: () => import('@/pages/EducationColumn/ColumnistDetail').catch(reloadPage),
    },
    // 学校合作专题页
    {
      path: '/partner/:type(\\w+)',
      name: 'PartnerTopicDetail',
      component: () => import('@/pages/PartnerTopic/Detail').catch(reloadPage),
    },
    // 聚合好课主题页
    {
      path: '/custom/collection',
      name: 'CustomCollection',
      component: () => import('@/pages/CustomCollection').catch(reloadPage),
    },
    // 聚合好课主题页
    {
      path: '/multi/product/wechat/group',
      name: 'MultiProductWeChatGroup',
      component: () => import('@/pages/MultiProductWeChatGroup').catch(reloadPage),
    },
    // 小程序审核版详情页
    {
      path: '/mini/product/verify',
      name: 'MiniProductVerifyDetail',
      component: () => import('@/pages/MiniProductVerify/Detail').catch(reloadPage),
    },
    // 选课助手主页面
    {
      path: '/select/course/assistant',
      name: 'SelectCourseAssistant',
      component: () => import('@/pages/SelectCourseAssistant').catch(reloadPage),
    },
    // 选课助手推荐课程页面
    {
      path: '/select/course/assistant/recommend',
      name: 'SelectCourseAssistantRecommend',
      component: () => import('@/pages/SelectCourseAssistant/Recommend').catch(reloadPage),
    },
    // 新人福利页
    {
      path: '/welfare/new/member/gift',
      name: 'WelfareDetail',
      component: () => import('@/pages/WelfareNewMember/Detail').catch(reloadPage),
      meta: { selfJumpWebview: true },
    },
    // 下载App
    {
      path: '/download/app',
      name: 'DownLoad',
      component: () => import('@/pages/DownLoad').catch(reloadPage),
    },
    // 下载App 通配App 链接
    {
      path: '/download/app*',
      name: 'DownLoad',
      component: () => import('@/pages/DownLoad').catch(reloadPage),
    },
    // 账户锁定页面
    {
      path: '/account/lock',
      name: 'AccountLock',
      component: () => import('@/pages/AccountLock').catch(reloadPage),
      meta: { selfJumpWebview: true },
    },
    // 账号注销
    {
      path: '/account/logoff',
      name: 'AccountLogoff',
      component: () => import('@/pages/AccountLogoff').catch(reloadPage),
      meta: { auth: true },
    },
    // 账号绑定
    {
      path: '/account/binding',
      name: 'AccountBinding',
      component: () => import('@/pages/AccountBinding').catch(reloadPage),
      meta: { auth: true },
    },
    // 手机号验证
    {
      path: '/mobile/verify',
      name: 'MobileVerify',
      component: () => import('@/pages/MobileVerify').catch(reloadPage),
    },
    // 验证码验证
    {
      path: '/mobile/verify/by/sms',
      name: 'MobileVerifyBySMS',
      component: () => import('@/pages/MobileVerify/SMS').catch(reloadPage),
    },
    // TED演讲课表
    {
      path: '/static/ted/timetable/:id',
      name: 'StaticTedTimeTable',
      component: () => import('@/pages/Static/TedTimeTable').catch(reloadPage),
    },
    {
      path: '/500',
      name: 'Error500',
      component: () => import('@/pages/Error/500').catch(reloadPage),
    },
    {
      path: '/403',
      name: 'Error403',
      component: () => import('@/pages/Error/403').catch(reloadPage),
    },
    {
      path: '/404',
      name: 'Error404',
      component: () => import('@/pages/Error/404').catch(reloadPage),
    },
    // App 动作路由
    // App 展示二维码：{ name: 'AppQrCodeDetail', params: { qrCode, hint, name }}
    // App 分享：{ name: 'AppBaseShare', params: { title, desc, link, imgUrl } }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    const position = {};
    if (to.hash) {
      position.selector = to.hash;
      if (document.querySelector(to.hash)) {
        return position;
      }
    }
    return new Promise((resolve) => {
      position.x = 0;
      position.y = 0;
      resolve(position);
    });
  },
});

const inWebView = isAppWebView();
let isLandingPage = true;

/**
 * 是否有效token
 * @param token
 * @returns {*|boolean}
 */
function validToken(token) {
  return token && token !== '' && token !== '-1';
}

/**
 * 更新token
 * @param to
 * @param from
 * @returns {Promise<any>}
 */
function updateToken(to, from) {
  return new Promise(async (resolve, reject) => {
    // 获取URI query 中的token 进行登录
    const { query } = to;
    const {
      [MINI_PROGRAM_TOKEN_NAME]: miniToken,
      [APP_TOKEN_NAME]: mApiToken,
    } = query;
    // 处理app webview 退出登录
    const { name: fromName, meta } = from;
    const blackList = ['Login', 'Register', 'PromptMessage'];
    const isBlackList = blackList.includes(fromName);
    const fromAuth = meta ? meta.auth : false;
    const { updateAppTokenCount } = store.getters;
    // 上一页非必须登录页也非登录、注册页，token 为 -1
    if (updateAppTokenCount !== 1 && mApiToken === '-1' && !fromAuth && !isBlackList) {
      try {
        await store.dispatch('Logout');
        store.dispatch('toggleUpdateAppTokenCount', 1);
        return resolve();
      } catch (e) {
        return reject(e);
      }
    }
    // 处理app webview 登录
    const shouldUpdateMini = isMiniWebView() && validToken(miniToken);
    const shouldUpdateApp = isAppWebView() && validToken(mApiToken);
    if (shouldUpdateMini || shouldUpdateApp) {
      // 清空当前登录用户信息
      setAuth('');
      try {
        // 尝试使用query token 登录
        await store.dispatch('LoginWithQueryToken', {
          miniToken,
          mApiToken,
        });
        return resolve();
      } catch (e) {
        return reject(e);
      }
    }
    return resolve();
  });
}

router.beforeEach(async (to, from, next) => {
  // 处理App web view
  if (inWebView) {
    const { query } = to;
    const { webviewcount, appHideBenefit } = query;

    const ymDevice = query.ym_device;
    if (ymDevice && ymDevice !== '') {
      setYmDevice(ymDevice);
    }

    if (appHideBenefit && appHideBenefit !== '') {
      sessionStorage.setItem('appHideBenefit', appHideBenefit);
    }

    // webviewcount 为marketing项目路由添加的参数（前端写死的）
    const notFirstWebViewPage = webviewcount === '2';

    // 活动页内的二次跳转永远跳转到H5页面，无法跳转到App原生页面
    if (isLandingPage && notFirstWebViewPage) {
      // 更新token
      await updateToken(to, from);
      isLandingPage = false;
      next();
      return;
    }
    // 非第一页，且需进行WebView 跳转，则跳转至App路由
    const { meta: metaFrom, name: fromName } = from;
    const { meta: metaTo } = to;
    console.log('metaTo.selfJumpWebview || metaFrom.internalJumpWebview', metaTo.selfJumpWebview || metaFrom.internalJumpWebview);
    if (metaTo.selfJumpWebview || metaFrom.internalJumpWebview) {
      const dismiss = fromName === 'PayNotify';
      const res = locationToAppWithRoute(to, dismiss);
      if (res) return;
    }
  }

  // 处理外链
  const extraLinkIndex = to.fullPath.search(/http(s?):\/\//);
  if (extraLinkIndex !== -1) {
    locationHref(to.fullPath.slice(extraLinkIndex));
    return;
  }

  // 处理404
  if (!to.matched || to.matched.length === 0) {
    next({ name: 'Error404', replace: true });
    return;
  }

  // 更新token
  await updateToken(to, from);
  // 更新用户验证
  const auth = getAuth();

  // 获取是否新建App
  const { newApp } = store.getters;
  if (newApp && auth === '') {
    // 尝试登录
    const data = await getUserLoginWithToken();
    if (data.isLock) {
      locationHref(`${window.location.origin}/account/lock?lockToken=${data.lockToken}`);
      return;
    }
    // 设置当前单页应用非新建
    store.dispatch('toggleNewApp', false);
  }

  // 处理需要登录才能浏览的页面
  const { meta } = to;
  if (meta && meta.auth) {
    if (!auth || auth === '') {
      const { fullPath } = to;
      next({ name: 'Login', query: { redirectTo: fullPath } });
      return;
    }
  }
  next();
});

router.afterEach((to) => {
  Promise.resolve().then(() => {
    // 更新origin
    setOrigin();
    // 事件埋点上报页面
    Vue.prototype.$reporter.reportPage();

    const { meta = {} } = to;
    const { tab } = meta;
    // 处理返回按钮展示
    store.dispatch('toggleShowBack', !tab);
    // 设置微信配置
    setWechatConfig();
    // 更新微信分享信息
    updateWechatShareInfo();
  });
});

export default router;
